/**
 * IP Lookup Utility
 * Provides functionality for fetching a user's IP address using a public service.
 */

/**
 * Fetches the user's IP address using a public IP lookup service
 * @returns {Promise<string>} A promise that resolves to the user's IP address
 */
export const fetchIpAddress = async () => {
  try {
    // Use a public IP lookup service
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    if (data && data.ip) {
      console.log("User IP address:", data.ip);
      return data.ip;
    }
    return "";
  } catch (error) {
    console.error("Error fetching IP address:", error);
    // Return empty string if we can't get the IP
    return "";
  }
};

/**
 * Gets the URL for a file in the public folder
 * @param {string} fileName Name of the file
 * @returns {string} Full URL to the file
 */
export const getPublicFileUrl = (fileName) => {
  const baseUrl = window.location.origin;
  // Try various possible locations
  const paths = [
    `${baseUrl}/${fileName}`,
    `${baseUrl}/public/${fileName}`,
    `${process.env.PUBLIC_URL}/${fileName}`,
    `/${fileName}`,
  ];

  console.log(`[IPLookupUtil] Public file paths for ${fileName}:`, paths);

  // Return first path (default) but log all possibilities
  return paths[0];
};

export default {
  fetchIpAddress,
  getPublicFileUrl,
};
